<script setup>
import {} from "vue";
import { useLoadingStore } from "@/store/loading";
const loadingStore = useLoadingStore();
</script>
<template>
  <div
    class="loading-mask"
    v-if="loadingStore.pageIsLoading"
    :class="loadingStore.background == true ? 'background' : ''"
  >
    <section
      class="d-flex flex-column w-100 h-100 justify-content-center align-items-center"
    >
      <img src="@/assets/icon/loading-round.svg" alt="loading" />
      <div class="loading loading02">
        <span>L</span>
        <span>o</span>
        <span>a</span>
        <span>d</span>
        <span>i</span>
        <span>n</span>
        <span>g</span>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
.loading-mask {
  position: fixed;
  background-color: rgba(255, 255, 255, 0.3);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
}
.background {
  // background: linear-gradient(120deg, #f8ffe8, #4f764f);
  background: rgba(0, 0, 0, 1);
}
.loading {
  font-size: 22px;
  text-align: center;
  letter-spacing: 2px;
  color: #fff;
  span {
    display: inline-block;
    margin: 0 -0.05em;
  }
}

.loading02 {
  span {
    // animation: loading02 1.2s infinite alternate;
    // @for $i from 1 through 6 {
    //   &:nth-child(#{$i + 1}) {
    //     animation-delay: #{$i * 0.2}s;
    //   }
    // }
  }
}
@keyframes loading02 {
  0% {
    filter: blur(0);
    opacity: 1;
  }
  100% {
    filter: blur(5px);
    opacity: 0.2;
  }
}
</style>
